export default function classesCss(colunas) {

    // Verifica se a valor passado está nulo ou vazio
    const cols = colunas ? colunas.split(' ') : []
    // Inicializa a variavel que armazena as classes
    let classes = ''
    // Pega os valores das classes
    if(cols[0]) classes += ` p-col-${cols[0]}`
    if(cols[1]) classes += ` p-md-${cols[1]}`
    if(cols[2]) classes += ` p-lg-${cols[2]}`

    return classes
}